import PaymentCategories from '../../../enums/PaymentCategories';
import page from '../../page/page';
import getExpressOptionIndex from '../../selectors/ExpressSelectors/getExpressOptionIndex';
import getIsUsingExpressCheckout from '../../selectors/ExpressSelectors/getIsUsingExpressCheckout';
import {getPaymentOptions} from '../../selectors/PaymentOptionSelectors/PaymentOptionSelectors';
import Track from '../../utils/tracking';
import {exitExpressCheckoutFlow} from '../expressCheckoutActions';
import {getOrderSummaryForPaymentOption} from '../orderSummaryActions';
import {setPaymentOptionIndex} from './payment-actions';

export const changeSelectedPaymentMethod = (
  newPaymentOptionIndex,
  changeCause,
  shouldNotExitExpress = false,
  selectedPaymentCategory = PaymentCategories.NONE,
) => (dispatch, getState) => {
  if (Number.isInteger(newPaymentOptionIndex)) {
    const paymentOptions = getPaymentOptions(getState());
    
    if (getIsUsingExpressCheckout(getState())) {
      const expressOptionIndex = getExpressOptionIndex(getState());
      
      if (expressOptionIndex > -1 && expressOptionIndex !== newPaymentOptionIndex && !shouldNotExitExpress) {
        dispatch(exitExpressCheckoutFlow('Selecting new payment', false, true));
      }
    }
    
    dispatch(setPaymentOptionIndex(newPaymentOptionIndex));
    
    // Order Summary wont be fetched if newPaymentOptionIndex is -1
    const paymentOption = paymentOptions[newPaymentOptionIndex];
    let selectedPaymentCategorySymbol = selectedPaymentCategory;
    if (typeof selectedPaymentCategory !== 'symbol') {
      selectedPaymentCategorySymbol = PaymentCategories.NONE;
    }
    
    if (paymentOption && page.isOnPage('checkout')) {
      // Making payment option name ADYEN_V2--type if Adyen V2 option for bq tracking purposes in getOrderSummaryForPaymentOption function
      const paymentOptionName = paymentOption.isAdyenV2Option ? `ADYEN_V2--${paymentOption.type}` : paymentOption.name.toLowerCase();
      return dispatch(getOrderSummaryForPaymentOption(paymentOptionName, newPaymentOptionIndex, changeCause, selectedPaymentCategorySymbol.description));
    }
  }
};

export const changeSelectedPaymentMethodByName = paymentMethod => (dispatch, getState) => {
  const newPaymentOptionIndex = getState().payment.options
    .findIndex(paymentOption => paymentOption.name === paymentMethod);
  
  if (newPaymentOptionIndex !== -1) {
    dispatch(setPaymentOptionIndex(newPaymentOptionIndex));
  } else {
    Track.error(`Attempted to select ${paymentMethod}, which is not available on page`);
  }
};
